// 409（競合）時にユーザーへ出す文言を組み立てる。
//
// サーバは競合の種類ごとに違うメッセージを返す（本体の更新か、別画面からの
// 成果物リレーション変更か）。固定文言に置き換えると後者が「このレコードが
// 更新されました」と表示され、再読み込みしても自分の編集内容は無傷なのに
// 原因が分からなくなる。サーバのメッセージを原因として出し、入力内容を
// 失わないための操作案内を続ける。
const INPUT_RECOVERY_GUIDE =
  '入力した内容は画面に残っています。\n'
  + 'OK を押した後、メモなど必要な内容をコピーしてから\n'
  + 'キャンセルで閉じて最新データを確認してください。';

// サーバがメッセージを返さなかった場合の原因表示
const FALLBACK_CONFLICT_CAUSE = '他のユーザーによってこのレコードが更新されました。';

export function buildConflictMessage(serverMessage) {
  const cause = (serverMessage || '').trim() || FALLBACK_CONFLICT_CAUSE;
  return `${cause}\n${INPUT_RECOVERY_GUIDE}`;
}
